import { DAY_KEYS } from "@/lib/days";
import type { WidgetWeekEntry } from "@/lib/schema";

/**
 * Helpers for `describeWeekData` — what a week would lose if a widget were
 * dropped from it (docs/adr/0014). Deliberately free of any registry import:
 * the kinds themselves use these, and the registry imports the kinds.
 */

/** Total a per-day figure across the seven days of a day-scope entry. */
export function sumOverDays<TDay>(
  entry: WidgetWeekEntry,
  count: (day: TDay) => number,
): number {
  if (!("days" in entry)) return 0;
  return DAY_KEYS.reduce(
    (total, key) => total + count(entry.days[key] as TDay),
    0,
  );
}

/** "1 natt" / "4 netter", or null at zero — nothing to warn about. */
export function countPhrase(
  count: number,
  singular: string,
  plural: string,
): string | null {
  if (count <= 0) return null;
  return `${count} ${count === 1 ? singular : plural}`;
}
